module.exports = __webpack_public_path__ + "media/images/transfer-f709061a3b9292e0db062eb9cdf4bbef.svg";